export const appHead = {"meta":[{"name":"charset","content":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"http-equiv":"Content-Type","content":"text/html; charset=UTF-8"},{"http-equiv":"Cache-Control","content":"private, max-age=0, no-cache, must-revalidate"},{"property":"og:title","content":"Macy’s– Official Site"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://www.macys.com"},{"property":"og:description","content":"FREE Shipping on the latest fashion brands on Women’s and Men’s Clothing, Accessories, Jewelry, Beauty, Shoes and Home Products."},{"property":"og:image","content":"https://www.macys.com/img/nav/co_macysLogo3.gif"},{"property":"og:site_name","content":"Macy’s"},{"property":"fb:app_id","content":"172562576126509"},{"name":"google-site-verification","content":"NXerNZgQYWmrno0UECIRSi5eHUACZ-5TThhQOA3SFvU"}],"link":[],"style":[],"script":[{"innerHTML":"window.isNuxtApp = true","tagPosition":"head","type":"text/javascript"},{"tagPosition":"bodyClose","type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"name\":\"Macy’s\",\"legalName\":\"Macy’s, Inc.\",\"description\":\"Shop Macy’s for fashion, home, beauty, and more. Discover brands you love with curated selections and everyday style.\",\"logo\":\"https://www.macys.com/img/nav/co_macysLogo3.gif\",\"areaServed\":\"US\",\"url\":\"https://www.macys.com/\",\"brand\":[\"Macy’s\"],\"sameAs\":[\"https://www.facebook.com/macys/\",\"https://x.com/macys\",\"https://www.instagram.com/macys/\",\"https://www.pinterest.com/macys/\",\"https://www.linkedin.com/company/macys\",\"https://www.tiktok.com/@macys\",\"https://en.wikipedia.org/wiki/Macy%27s\"],\"contactPoint\":[{\"@type\":\"ContactPoint\",\"telephone\":\"+1-800-289-6229\",\"contactType\":\"customer service\",\"areaServed\":\"US\"}]}"}],"noscript":[],"htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = true

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false